import { Component, Input } from '@angular/core';
import { SidenavItem } from '../../../sidenav/sidenav-item/sidenav-item.model';

@Component({
  selector: 'vr-toolbar-navigation-item',
  templateUrl: './toolbar-navigation-item.component.html',
  styleUrls: ['./toolbar-navigation-item.component.scss']
})
export class ToolbarNavigationItemComponent {

  @Input('item') item: SidenavItem;
  @Input('currentlyOpen') currentlyOpen: SidenavItem[] = [];

  constructor() { }
}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/toolbar/toolbar-navigation/toolbar-navigation-item/toolbar-navigation-item.component.ts